import { handleActions } from 'redux-actions';
import { GET_ADMINS_LIST_SUCCESS } from '../actions/actionTypes';

const initialState = {
  adminsList: [],
  pagesQuantity: 0
};

export default handleActions(
  {
    [GET_ADMINS_LIST_SUCCESS]: (state, action) => ({
      ...state,
      adminsList: action.adminsList,
      pagesQuantity: action.pagesQuantity
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/admins.js